// extracted by mini-css-extract-plugin
export default {"miniappOverlay":"addBalance_miniappOverlay__-mzQO","historyTriggerBtn":"addBalance_historyTriggerBtn__IUfaM"};